/**
 * Analytics Reports Page (Web)
 * Placeholder for analytics reports
 */

import { Container, Typography, Box } from '@mui/material';
import { AuthenticatedLayout } from '../../components/layout/AuthenticatedLayout';

export function AnalyticsReportsPage() {
  return (
    <AuthenticatedLayout>
      <Container maxWidth="lg">
        <Box sx={{ mt: 4 }}>
          <Typography variant="h4" component="h1" gutterBottom>
            Analytics Reports
          </Typography>
          <Typography variant="body1" color="text.secondary">
            Reports feature coming soon...
          </Typography>
        </Box>
      </Container>
    </AuthenticatedLayout>
  );
}

